import { IconBase } from './IconBase'
import type { IconProps } from './IconBase'

export const IconMenu = (props: IconProps) => (
  <IconBase {...props}>
    <svg
      viewBox="0 0 19 12"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="12"
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.62696 0H17.73C18.252 0 18.679 0.427 18.679 0.949V1.051C18.679 1.573 18.252 2 17.73 2H1.62696C1.10496 2 0.678955 1.573 0.678955 1.051V0.949C0.678955 0.427 1.10496 0 1.62696 0ZM17.73 5H1.62696C1.10496 5 0.678955 5.427 0.678955 5.949V6.051C0.678955 6.573 1.10496 7 1.62696 7H17.73C18.252 7 18.679 6.573 18.679 6.051V5.949C18.679 5.427 18.252 5 17.73 5ZM17.73 10H1.62696C1.10496 10 0.678955 10.427 0.678955 10.949V11.051C0.678955 11.573 1.10496 12 1.62696 12H17.73C18.252 12 18.679 11.573 18.679 11.051V10.949C18.679 10.427 18.252 10 17.73 10Z"
      />
    </svg>
  </IconBase>
)